import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {OnChangePayload, TypeEnum} from "../../models";

@Component({
  selector: 'element-state-field',
  templateUrl: './state-field.component.html',
  styleUrls: ['./state-field.component.scss']
})
export class StateFieldComponent implements OnInit, OnChanges{

  constructor() {
  }

  @Output() change: EventEmitter<OnChangePayload> = new EventEmitter();

  @Input() option: StateToggleOption = {
    group: 'shipped',
    data: [{
      id: 0,
      value: false,
      label: 'Pending',
      icon: 'icon-freight-outline',
      color: '#d1d1d1',
      textColor: '#ffffff'

    },
      {
        id: 1,
        value: true,
        label: 'Complete',
        icon: 'icon-plane-outline',
        color: '#559765',
        textColor: '#ffffff'
      }],
    selected: false,
  };

  @Output() changed = new EventEmitter<boolean>(false);
  @Input() selected = false;

  @Input()
  selected_value: StateFieldData | undefined;

  getLabel() {
    if (this.option.data?.length != 2) {
      return "";
    }
    return (this.option.selected) ? this.option.data[1].label : this.option.data[0].label;

  }

  changeState() {
    this.option.selected = !this.option.selected;
    this.change.emit({
      type: TypeEnum.StateField,
      id: 'shipped',
      payload: this.option.selected
    });
  }

  ngOnInit(): void {
    this.option.selected = this.selected;
    this.changed.emit(this.selected);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.selected){
      this.option.selected  = changes.selected.currentValue;
    }
  }

}

export interface StateToggleOption {
  group: string;
  selected: boolean;
  data?: StateFieldData[];
}

export interface StateFieldData {
  id?: any;
  value: boolean;
  label: string;
  icon?: string;
  color?: string;
  textColor?: string;
}
